import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { LogOut } from 'react-feather';

const SessionEnded = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md="6" lg="5">
            <div className="bg-white p-5 rounded shadow-sm">
              <div className="mb-4">
                <LogOut size={80} className="text-danger" />
              </div>

              <h3 className="fw-semibold mb-3">You have been logged out</h3>

              <p className="text-muted mb-0">
                Your session has ended. This usually happens when your account is signed in
                from another device or an administrator has ended your session. Please return
                to your main application to sign in again.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SessionEnded;

